// de strings for messages/checkout.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const checkout: Dict = {
  "checkout.declined":
    "Deine Karte wurde abgelehnt. Wende dich an deine Bank oder probier eine andere Zahlungsmethode.",
  "checkout.trialStarted": "Deine kostenlose Testphase hat begonnen!",
  "checkout.thanks": "Danke für deinen Kauf!",
  "checkout.startTrial": "Kostenlos testen",
  "checkout.pay": "Bezahlen",
};

export default checkout;
